export default __webpack_public_path__ + "static/media/photo-owner-2.1dbae7e1.png";